import { render, staticRenderFns } from "./g1-dns.vue?vue&type=template&id=7de51101&scoped=true&"
import script from "./g1-dns.vue?vue&type=script&lang=js&"
export * from "./g1-dns.vue?vue&type=script&lang=js&"
import style0 from "./g1-dns.vue?vue&type=style&index=0&id=7de51101&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de51101",
  null
  
)

export default component.exports